import './styles.scss';

import CustomInvoiceTableHeader from './CustomInvoiceTableHeader';
import CustomInvoiceTableRow from './CustomInvoiceTableRow';
import Table from '@/common/Table';
import { getClasses } from '@/utils';

export type CustomInvoiceTableProps = {
  data?: any[];
  onDelete?: (id?: string) => () => void;
  preview?: any;
  setPreview?: (preview: any) => void;
};

const CustomInvoiceTable = ({ data, onDelete, preview, setPreview }: CustomInvoiceTableProps): JSX.Element => {
  return (
    <Table className={getClasses('CustomInvoiceTable')} header={<CustomInvoiceTableHeader onDelete={onDelete} />} showControls>
      {data.map(
        (row: any, index: number): JSX.Element => (
          <CustomInvoiceTableRow
            {...row}
            index={row?.index || index}
            onDelete={onDelete?.(row?.id)}
            preview={preview}
            setPreview={setPreview}
            key={row?.id || index}
          />
        )
      )}
    </Table>
  );
};

export default CustomInvoiceTable;
